'use strict';

module.exports = function requirePromise() {
	if (typeof Promise !== 'function') {
		throw new TypeError('`Promise.allSettled` requires a global `Promise` be available.');
	}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/promise.allsettled/requirePromise.js
// module id = 328
// module chunks = 29